import { Empty, Typography } from 'antd';
import type { RouteDef } from '../app/routes';

export function Placeholder({ route }: { route: RouteDef }) {
  return (
    <>
      <Typography.Title level={3}>{route.label}</Typography.Title>
      <Typography.Paragraph type="secondary">{route.description}</Typography.Paragraph>
      <Empty description={`준비 중 (${route.issues.map((n) => `#${n}`).join(', ')})`} />
    </>
  );
}
